import {
  BasketValidationResultModel,
  DtoBasket,
} from '@epicuro-next/data/baskets-dto';
import { CheckOrderResult, Severity } from 'graphql-api/baskets-api-interfaces';

export const accountValidationKeys = ['Validation_Account_Suspended'];

/**
 * Creates check order result from response.
 */
export function createCheckOrderResult(basket: DtoBasket): CheckOrderResult {
  const validationResults =
    basket.validationResults?.map(mapValidationResult) ?? [];

  const accountValidationResults = mapAccountValidationResults(basket);

  const items = basket.items?.map((item) => ({
    productId: item.productId,
    basketItemId: item.itemId,
    confirmedQuantity: item.confirmedQuantity,
    expectedDeliveryDate: item.expectedDeliveryDate,
    validationResults: item.validationResults?.map(mapValidationResult) ?? [],
    prices: item.prices,
  }));

  return {
    validationResults,
    accountValidationResults,
    items,
  };
}

export function mapValidationResult(item: BasketValidationResultModel): {
  message?: string;
  translationKey?: string;
  severity: Severity;
  values?: string[];
} {
  return {
    message: mapMessage(item.message, item.values),
    translationKey: item.translationKey,
    severity: mapSeverity(item.severity),
    values: item.values,
  };
}

export function mapAccountValidationResults(basket: DtoBasket) {
  const validationResults = basket.validationResults
    ?.filter(
      (e) =>
        e.translationKey &&
        accountValidationKeys.indexOf(e.translationKey) !== -1,
    )
    .map(mapValidationResult);

  return validationResults
    ?.flatMap((result) => result.values ?? [])
    .map((accountId) => {
      const basketAccounts = basket.basketAccounts.filter(
        (basketAccount) => basketAccount.account.accountId === accountId,
      );

      return {
        accountId,
        addressIds: basketAccounts?.map(
          (basketAccount) => basketAccount.address.addressId,
        ),
        validationResults: validationResults.filter(
          (validationResult) =>
            validationResult.values?.indexOf(accountId) !== -1,
        ),
      };
    });
}

const severityMap: { [key: number]: Severity } = {
  [5]: Severity.Critical,
  [4]: Severity.Error,
  [3]: Severity.Warning,
  [2]: Severity.Information,
  [1]: Severity.Debug,
};

function mapSeverity(severity: number) {
  return severityMap[severity];
}

function mapMessage(message?: string, errorValues?: string[]) {
  const errorValuesPlaceholder = '[[ERROR_VALUES]]';
  return message && errorValues && errorValues.length > 0
    ? message.replace(errorValuesPlaceholder, errorValues.join(','))
    : message;
}
